import type { Contact } from '@/contexts/contacts/types';
import { sendContactDB } from '@/scripts/dataBase';
import { ActionType } from '@/scripts/dataBase/type';
import { exportApis } from '@/scripts/utils/devUtils';

export const contactsApis = {
  addContacts(contacts: Contact[]) {
    return sendContactDB(ActionType.addContacts, {
      params: contacts,
    });
  },
  queryContacts(params: { limit: number; offset: number }) {
    return sendContactDB(ActionType.queryContacts, {
      params,
    });
  },
  queryContactById(id: string) {
    return sendContactDB(ActionType.queryContactById, {
      params: id,
    });
  },
  queryContactByUserId(userId: string) {
    return sendContactDB(ActionType.queryContactByUserId, {
      params: userId,
    });
  },
  deleteContacts(ids: string) {
    return sendContactDB(ActionType.deleteContacts, {
      params: ids,
    });
  },
  updateContacts(contacts: any[]) {
    return sendContactDB(ActionType.updateContacts, {
      params: contacts,
    });
  },
};

exportApis({ contactsApis });
